export default async () => {
  const controller = await import(
    /* webpackChunkName: "BraunCompareController-lib" */ '@/braun/Controllers/Listing/Compare/ListingCompareController'
  );
  controller.default();
};
